export class OmetriaForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  static get requiredElements () {
    return ['country-id', 'email', 'submit', 'fields', 'messages']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setCountryCodeInputValue()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'submit', this.handleSubmit.bind(this))

    this.listeners.add(
      this.els.email.element,
      'input',
      this.handleEmailInput.bind(this),
    )
  }

  /** @param {InputEvent} event */
  handleEmailInput (event) {
    this.setAttribute('data-email-valid', String(event.target.validity.valid))
  }

  /** @param {SubmitEvent} event */
  async handleSubmit (event) {
    event.preventDefault()

    const formElements = event.target.elements
    const urlEncodedDataPairs = Object.keys(formElements).map(key => {
      return `${encodeURIComponent(
        formElements[key].name,
      )}=${encodeURIComponent(formElements[key].value)}`
    })

    const formBody = urlEncodedDataPairs.join('&').replace(/%20/g, '+')

    const response = await fetch('https://api.ometria.com/forms/signup/ajax', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: formBody,
    })
      .then(response => {
        if (!response.ok) {
          throw response
        }
        return response.json()
      })
      .catch(error => {
        return error.json()
      })

    const messagesEl = this.els.messages.element
    messagesEl.setAttribute('aria-invalid', String(!response?.ok))

    if (response?.ok) {
      this.els.fields.element.setAttribute('aria-hidden', 'true')
      messagesEl.setAttribute('aria-hidden', 'false')
      messagesEl.innerHTML = messagesEl.dataset.translationNewsletterSuccess
    } else {
      messagesEl.setAttribute('aria-hidden', 'false')
      messagesEl.innerHTML = messagesEl.dataset.translationNewsletterError

      response?.errors?.forEach(
        error => (messagesEl.innerHTML += `<br />${error.pop()}`),
      )
    }
  }

  async setCountryCodeInputValue () {
    const countryId = await this.getCountryCode()

    this.els['country-id'].elements.forEach(countryIdEl => {
      countryIdEl.value = countryId
    })
  }

  async getCountryCode () {
    const browsingContext = await fetch(
      '/browsing_context_suggestions.json',
    ).then(response => {
      if (!response.ok) {
        throw response
      }
      return response.json()
    })

    return (
      browsingContext?.detected_values?.country?.handle ||
      this.defaultCountryCode
    )
  }

  get defaultCountryCode () {
    return 'GB'
  }
}

if (!customElements.get('ometria-form')) {
  customElements.define('ometria-form', OmetriaForm, { extends: 'form' })
}
